/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

// ----------------------------------------------------------------------

import RouterPointPay from 'src/routes/sections/router-pointpay';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import ThemeProvider from 'src/theme';

import AppUpdaterGuard from 'src/auth/guard/app-updater-guard';

import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsProvider } from 'src/components/settings';
import { NetworkGuard } from 'src/components/network-guard';
import NiceModal from '@ebay/nice-modal-react';
import { LocalizationProvider } from 'src/locales';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { StartupPlugins } from './utils/Providers/StartupPlugins';
import { PreferenceProvider } from './utils/Providers/PreferenceProvider';

// ----------------------------------------------------------------------

export default function AppPointPay() {
  const charAt = `
██████   ██████  ██ ███    ██ ████████ ██████   █████  ██    ██
██   ██ ██    ██ ██ ████   ██    ██    ██   ██ ██   ██  ██  ██
██████  ██    ██ ██ ██ ██  ██    ██    ██████  ███████   ████
██      ██    ██ ██ ██  ██ ██    ██    ██      ██   ██    ██
██       ██████  ██ ██   ████    ██    ██      ██   ██    ██
`;

  console.info(`%c${charAt}`, 'color: #5BE49B');
  console.info('PointCraft - PointPay');

  useScrollToTop();

  return (
    <LocalizationProvider>
      <StartupPlugins>
        <PreferenceProvider>
          <SettingsProvider
            defaultSettings={{
              themeMode: 'light',
              themeDirection: 'ltr',
              themeContrast: 'default',
              themeLayout: 'horizontal',
              themeColorPresets: 'default',
              themeStretch: true,
            }}
          >
            <ThemeProvider>
              <MotionLazy>
                <NiceModal.Provider>
                  <SnackbarProvider>
                    <ProgressBar />
                    <NetworkGuard>
                      <AppUpdaterGuard>
                        <RouterPointPay />
                      </AppUpdaterGuard>
                    </NetworkGuard>
                  </SnackbarProvider>
                </NiceModal.Provider>
              </MotionLazy>
            </ThemeProvider>
          </SettingsProvider>
        </PreferenceProvider>
      </StartupPlugins>
    </LocalizationProvider>
  );
}
